var map = {};

export default map;
//# sourceMappingURL=componentConstructorMap.js.map
